import { RefObject, useEffect, useRef } from 'react';

import { useFormStore } from '@/stores/formStore.ts';

const useFormRef = (): RefObject<HTMLFormElement | undefined> => {
    const ref = useRef<HTMLFormElement | undefined>(undefined);

    useEffect(() => {
        if (!ref.current) return;

        useFormStore.setState({ form_element: ref.current });
    }, [ref]);

    return ref;
};

export default useFormRef;
